module.exports = __webpack_public_path__ + "img/Error.2a24f6ca.png";